<template>
  <Dialog :open="open" @update:open="$emit('update:open', $event)">
    <DialogContent class="max-w-md">
      <DialogHeader>
        <DialogTitle>{{ t('preorder_confirmation.title') }}</DialogTitle>
      </DialogHeader>

      <div class="space-y-4">
        <div class="text-sm text-gray-600 whitespace-pre-line" v-html="t('preorder_confirmation.content')"></div>

        <div class="flex items-start space-x-2">
          <Checkbox 
            id="preorder-acknowledgment" 
            v-model:model-value="acknowledged" 
            :required="true"
            class="mt-1"
          />
          <Label 
            for="preorder-acknowledgment" 
            class="text-sm leading-5 cursor-pointer"
          >
            {{ t('preorder_confirmation.checkbox') }}
          </Label>
        </div>
      </div>

      <DialogFooter>
        <Button 
          @click="handleConfirm" 
          :disabled="!acknowledged || loading"
          class="w-full"
        >
          <SfProgressCircular v-show="loading" class="mr-2!" size="sm" />
          {{ t('preorder_confirmation.button') }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { Button } from '~/components/ui/button';
import { Checkbox } from '~/components/ui/checkbox';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Label } from '~/components/ui/label';
import { SfProgressCircular } from '@storefront-ui/vue';

interface Props {
  open: boolean;
  loading?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
});

const emit = defineEmits<{
  'update:open': [value: boolean];
  'confirm': [];
}>();

const { t } = useI18n();
const acknowledged = ref(false);

function handleConfirm() {
  if (!acknowledged.value) return;
  emit('confirm');
}

// Reset acknowledgment when modal closes
watch(() => props.open, (newOpen) => {
  if (!newOpen) {
    acknowledged.value = false;
  }
});
</script>
